import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../apiSetup/apiCall';

const initialState = {
  list: [['all','All']],
  appliedFilter: ['all','All']
};

export const fetchFacilityLocationTypeFilterList = createAsyncThunk('facilityLocationTypeList/fetchFacilityLocationTypeFilterList', async () => {
  try {
    const response = await api.get('prometheus/facility/type/list/');
    return response.data;
  } catch (error) {
    console.error('Error fetching facility location type list:', error);
    throw error;
  }
});

const FacilityLocationTypeFilterSlice = createSlice({
  name: 'facilityLocationTypeFilter',
  initialState,
  reducers: {
    changeFilter: (state, action) => {
      state.appliedFilter = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFacilityLocationTypeFilterList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchFacilityLocationTypeFilterList.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload?.data?.length > 0) {
          state.list = [ ['all','All'], ...(action.payload.data)]
        }
        else 
          state.list = [['all','All']]
      })
      .addCase(fetchFacilityLocationTypeFilterList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});


export const { changeFilter } = FacilityLocationTypeFilterSlice.actions;
export default FacilityLocationTypeFilterSlice.reducer;
